import { createSlice } from '@reduxjs/toolkit';
import { EXTERNAL_CANDIDATE_REPORT } from '../../actions/Reports/actionTypes';

const externalCandidateInitialState = {
  externalCandidate: {
    externalCandidatedata: [],
    dropDown: [],
    exportFileData: [],
    reportsData: [],
    isLoading: false,
    errors: ''
  }
};

export const externalCandidateSlice = createSlice({
  name: EXTERNAL_CANDIDATE_REPORT,
  initialState: externalCandidateInitialState,
  reducers: {
    /* This action will trigger our saga middleware
       and set the loader to true and reset error message.
    */

    getDropDownAction: (state) => {
      state.isLoading = true;
      state.externalCandidate.reportsData = [];
      state.externalCandidate.externalCandidatedata = [];
      state.externalCandidate.errors = '';
      state.externalCandidate.isLoading = true;
    },

    getDropDownSuccessAction: (state, action) => {
      if (action.payload) {
        state.externalCandidate.reportsData = [];
        state.externalCandidate.dropDown = action.payload;
        state.externalCandidate.externalCandidatedata = action.payload;
      }
      state.externalCandidate.isLoading = false;
    },
    getDropDownFailureAction: (state, action) => {
      state.externalCandidate.isLoading = false;
      state.externalCandidate.errors = action.payload;
    },
    getReportAction: (state) => {
      state.isLoading = true;
      state.externalCandidate.isLoading = true;
      state.externalCandidate.externalCandidatedata = [];
      state.externalCandidate.reportsData = [];
      state.externalCandidate.errors = '';
    },
    getReportSuccessAction: (state, action) => {
      if (action.payload) {
        state.externalCandidate.reportsData = [];
        state.externalCandidate.externalCandidatedata = action.payload;
      }
      state.externalCandidate.isLoading = false;
    },
    getReportFailureAction: (state, action) => {
      state.externalCandidate.isLoading = false;
      state.externalCandidate.errors = action.payload;
    },

    getExportFileAction: (state) => {
      state.isLoading = true;
      state.externalCandidate.errors = '';
    },

    getExportFileSuccessAction: (state, action) => {
      if (action.payload) {
        state.externalCandidate.exportFileData = action.payload;
      }
      state.externalCandidate.isLoading = false;
    },

    getExportFileFailureAction: (state, action) => {
      state.externalCandidate.isLoading = false;
      state.externalCandidate.errors = action.payload;
    },

    getIndividualReportAction: (state) => {
      state.isLoading = true;
      state.externalCandidate.reportsData = [];
      state.externalCandidate.externalCandidatedata = [];
      state.externalCandidate.errors = '';
    },

    getIndividualReportSuccessAction: (state, action) => {
      if (action.payload) {
        state.externalCandidate.reportsData = [];
        state.externalCandidate.externalCandidatedata = [];
        state.externalCandidate.reportsData = action.payload;
      }
      state.externalCandidate.isLoading = false;
    },

    getIndividualReportFailureAction: (state, action) => {
      state.externalCandidate.isLoading = false;
      state.externalCandidate.errors = action.payload;
    }
  }
});

/* getUserSuccessAction and getUserErrorAction will be used inside the saga
  middleware. Only getUserAction will be used in a React component.
*/

export const {
  getExportFileAction,
  getExportFileSuccessAction,
  getExportFileFailureAction,
  getReportAction,
  getReportSuccessAction,
  getReportFailureAction,
  getDropDownAction,
  getDropDownSuccessAction,
  getDropDownFailureAction,
  getIndividualReportAction,
  getIndividualReportSuccessAction,
  getIndividualReportFailureAction
} = externalCandidateSlice.actions;
export default externalCandidateSlice.reducer;
